<template>
  <el-col
    :span="access ? 6 : 8"
    class="direction"
    @click.native="$emit('passport', $event)"
  >
    <el-row>
      <el-tooltip
        class="item"
        effect="light"
        :content="`ID рейса - ${id}`"
        placement="top-start"
      >
        <span class="date" :data-path="path">{{ date }}</span>
      </el-tooltip>
      {{ points.from }}
      <span>({{ points.load }})</span>
    </el-row>
    <el-row class="flight__stevedore">
      <div>{{ points.stevedore }}</div>
      <div>({{ points.unload }})</div>
      <div v-if="bid.is_tudatka" class="tudatka">
        <i class="el-icon-right tudatka__icon" />
        <i class="el-icon-truck tudatka__icon" />
      </div>
    </el-row>
    <el-row>
      {{ bid.client_short_name }}
    </el-row>
  </el-col>
</template>

<script>
import shippingMixin from '@/mixins/shippingMixin'

export default {
  name: 'FlightDirection',
  mixins: [shippingMixin],
  props: {
    id: {
      type: Number,
      default: 0,
    },
    bid: {
      type: Object,
      default: () => {},
    },
    day: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    date() {
      const date = this.day ? this.day.load_date : ''

      return this.dateToFormat(date, 'shortDateWithoutYear')
    },
    path() {
      const isData = this.bid && this.day
      let path = '#'

      if (isData) {
        const { id: bidId } = this.bid
        const { id: dayId } = this.day

        if (bidId && dayId) {
          path = `/bid/${bidId}/load-day/${dayId}`
        }
      }

      return path
    },
    points() {
      let from,
        load,
        unload,
        stevedore = 'не указан'

      if (this.bid) {
        from = this.loadLocationFilter(this.bid)
        stevedore = this.findStevedore(this.bid)
        const { load_point, unload_point } = this.bid

        load = this.cutCity(load_point.split(',')[0])
        unload = this.cutCity(unload_point.split(',')[1])
      }

      return { from, load, stevedore, unload }
    },
    access() {
      return this.canAction('flightsAccess')
    },
  },
  methods: {
    cutCity(city) {
      return city ? city.replace('Город ', '') : ''
    },
  },
}
</script>

<style lang="sass">
.flight-item
  .el-col.direction
    font-size: 12px
    cursor: pointer
    span
      color: #BCBCBC
      &.date
        color: #3498DB
        font-weight: bold
        text-decoration: underline
        margin-right: 5px
  .flight__stevedore
    display: flex
    align-items: center
    .tudatka
      display: flex
      align-items: center
      margin-left: 6px
      &__icon
        font-size: 18px
        font-weight: 700
        color: #FF0000
</style>
